import { render, staticRenderFns } from "./LocationPlace.vue?vue&type=template&id=61814826&"
import script from "./LocationPlace.vue?vue&type=script&lang=js&"
export * from "./LocationPlace.vue?vue&type=script&lang=js&"
import style0 from "./LocationPlace.vue?vue&type=style&index=0&id=61814826&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports